import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

const UserWallet = () => {
  const { t: translate } = useTranslation();

  return (
    <Grid container justify="center" alignItems="center">
      <Typography variant="h5" color="textSecondary">{translate('update wallet')}</Typography>
    </Grid>
  )
};

export default UserWallet;